<template>
    <form class="max-w-2xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" v-if="signup">
            <form-field-text
                id="first-name"
                label="First name *"
                field="first_name"
                autocomplete="given-name"
                :value="signup.first_name"
                @update="updateSignupField"
            ></form-field-text>
            <form-field-text
                id="last-name"
                label="Last name *"
                field="last_name"
                autocomplete="family-name"
                :value="signup.last_name"
                @update="updateSignupField"
            ></form-field-text>
            <form-field-text
                class="sm:col-span-2"
                id="email"
                label="Email *"
                field="email"
                type="email"
                autocomplete="email"
                :value="signup.email"
                @update="updateSignupField"
            ></form-field-text>
            <form-field-checkbox
                class="sm:col-span-2"
                id="checkbox"
                :title="$config.public.settingsNotificationsMailersTitle"
                :label="$config.public.settingsNotificationsMailersText"
                :info="$config.public.settingsNotificationsMailersInfo"
                field="checkbox"
                @update="clickMailingListCheckbox"
            ></form-field-checkbox>
            <form-field-re-captcha
                class="mt-6"
                field="recaptcha_response"
                :onUpdate="updateSignupField"
                :error="error"
                :success="success"
            ></form-field-re-captcha>
        </div>
        <div class="mt-10">
            <button-block
                buttonText="Signup"
                :buttonDisabled="disabled || !signup.first_name || !signup.last_name || !signup.email"
                :buttonClick="postSignup"
            ></button-block>
            <alert-success class="mt-5" :alert="success" :onDismiss="clearSuccess"></alert-success>
            <alert-error class="mt-5" :alert="error" :onDismiss="clearError"></alert-error>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormSignup',
    computed: {
        ...mapState(useStoreSignup, {
            signup: 'signup',
            disabled: 'disabled',
            success: 'success',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreSignup, {
            initSignup: 'initSignup',
            updateSignupField: 'updateSignupField',
            postSignup: 'postSignup',
            clearError: 'clearError',
            clearSuccess: 'clearSuccess',
        }),
        clickMailingListCheckbox(response) {
            let value = response.value;
            if (this.updateSignupField && value !== undefined) {
                this.updateSignupField({field: 'notifications_mailers', value});
                this.updateSignupField({field: 'notifications_mailers_consent_method', value: 'toggle'});
                this.updateSignupField({
                    field: 'notifications_mailers_title',
                    value: this.$config.public.settingsNotificationsMailersTitle,
                });
                this.updateSignupField({
                    field: 'notifications_mailers_text',
                    value: this.$config.public.settingsNotificationsMailersText,
                });
                this.updateSignupField({
                    field: 'notifications_mailers_info',
                    value: this.$config.public.settingsNotificationsMailersInfo,
                });
            }
        },
    },
    created: function () {
        if (!this.signup) this.initSignup();
    },
};
</script>
